import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/about-us")({
  component: lazyRouteComponent(() => import("./-pages/admin.about-us")),
  head: () => ({ meta: [{ title: "About Us Page — Admin" }] }),
});
